import React, { useState } from "react";
import { Alert, Box, Button, Grid, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

import JusttawkLogo from "../../../../src/assets/Justtawk-01.png";
import LoginBg from "../../../../src/assets/LoginBg.jpeg";
import JusttawkBg from "../../../../src/assets/justtawk-bg.png";

import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/axiosInstance";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axios from "axios";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");

  const loginAdmin = async (values) => {
    const data = {
      email: values.email,
      password: values.password,
    };

    try {
      const res = await axios.post(apiEndPointsConfig.loginAdmin, data);

      // Save token + admin info
      localStorage.setItem("token", res?.data?.token);
      localStorage.setItem("adminId", res?.data?.admin?._id);
      localStorage.setItem("role", res?.data?.admin?.role);
      localStorage.setItem("fullName", res?.data?.admin?.fullName);
      localStorage.setItem("email", res?.data?.admin?.email);

      navigate("/admin/overview");
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || "Login failed");
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email").required("Email is required"),

      password: Yup.string()
        .required("Password is required")
        .min(6, "Password must be at least 6 characters"),
    }),
    onSubmit: (values) => {
      loginAdmin(values);
    },
  });

  return (
    <Box sx={{ height: "100%" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <Grid
          container
          sx={{
            mt: 0,
            height: { xs: "50vh", md: "100vh" },
          }}
        >
          {/* ---------------- LEFT SIDE IMAGE ---------------- */}
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            sx={{
              height: { xs: "50vh", md: "100vh" },
              backgroundImage: {
                xs: `url(${JusttawkBg})`,
                md: `url(${LoginBg})`,
              },
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              color: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              p: { xs: "20px", md: "100px 0" },
              mt: { xs: "-100px", md: "0px" },
            }}
          >
            <Box sx={{ textAlign: "center" }}>
              <Typography
                sx={{
                  fontWeight: { xs: 400, md: 900 },
                  fontSize: { xs: "1.1rem", md: "1.8rem" },
                }}
              >
                Welcome to{" "}
                <Box sx={{ display: { xs: "inline", md: "inline" } }}>
                  Justtawk
                </Box>
              </Typography>

              <Typography sx={{ fontSize: "1rem", fontWeight: 100 }}>
                Your Gateway to Effortless Call Center.
              </Typography>
            </Box>
          </Grid>

          {/* ---------------- RIGHT SIDE FORM ---------------- */}
          <Grid
            item
            xs={12}
            sm={8}
            md={4}
            sx={{
              p: { xs: "0 40px", md: "0 50px" },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
              maxWidth: "500px",
              mx: "auto",
            }}
          >
            <form onSubmit={formik.handleSubmit}>
              <Typography
                sx={{
                  fontSize: "2rem",
                  fontWeight: 900,
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Admin Login
              </Typography>

              <Typography
                sx={{
                  color: "#26203B",
                  mt: 2,
                  fontSize: "0.9rem",
                }}
              >
                Please enter your Email and Password*
              </Typography>

              {/* EMAIL */}
              <TextField
                id="email"
                name="email"
                variant="outlined"
                fullWidth
                placeholder="Email"
                margin="normal"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                InputProps={{
                  style: {
                    height: "40px",
                    borderRadius: "8px",
                    boxShadow: "rgba(149,157,165,0.2) 0px 8px 24px",
                  },
                }}
              />

              {/* PASSWORD */}
              <TextField
                id="password"
                name="password"
                type="password"
                variant="outlined"
                fullWidth
                placeholder="Password"
                margin="normal"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.password && Boolean(formik.errors.password)
                }
                helperText={formik.touched.password && formik.errors.password}
                InputProps={{
                  style: {
                    height: "40px",
                    borderRadius: "8px",
                    boxShadow: "rgba(149,157,165,0.2) 0px 8px 24px",
                  },
                }}
              />

              {/* SUBMIT BUTTON */}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={{
                  mt: 3,
                  mb: 2,
                  bgcolor: "#3652E2",
                  textTransform: "capitalize",
                }}
              >
                Login
              </Button>

              {errorMessage && (
                <Alert severity="error" sx={{ mt: 1 }}>
                  {errorMessage}
                </Alert>
              )}
            </form>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
